// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3CaiS","selects":"Documents_selects__2Fc_0"};